import { useMutation, useQueryClient } from "@tanstack/react-query";
import tradeService from "../services/trade.service";
import toast from "react-hot-toast";

export const useScale = () => {
  const queryClient = useQueryClient();
  const { isPending: isScalingIn, mutate: scaleIn } = useMutation({
    mutationFn: (data) => tradeService.scaleIn(data),
    onSuccess: () => {
      toast.success("Scale in successful");
      queryClient.invalidateQueries({
        queryKey: ["trade"],
      });
    },
    onError: (err) => {
      console.log(err);
      toast.error(err.toString() || " Something went wrong ");
    },
  });

  const { isPending: isScalingOut, mutate: scaleOut } = useMutation({
    mutationFn: (data) => tradeService.scaleOut(data),
    onSuccess: () => {
      toast.success("Scale out successfully");
      queryClient.invalidateQueries({
        queryKey: ["trade"],
      });
    },
    onError: (err) => {
      toast.error(err.toString() || " Something went wrong ");
    },
  });

  const { isPending: isScaleInEditing, mutate: editScaleIn } = useMutation({
    mutationFn: (data) => tradeService.editScaleIn(data),
    onSuccess: () => {
      toast.success("Scale edited successfully");
      queryClient.invalidateQueries({
        queryKey: ["trade"],
      });
    },
    onError: (err) => {
      toast.error(err.toString() || " Something went wrong ");
    },
  });

  const { isPending: isScaleOutEditing, mutate: editScaleOut } = useMutation({
    mutationFn: (data) => tradeService.editScaleOut(data),
    onSuccess: () => {
      toast.success("Scale edited successfully");
      queryClient.invalidateQueries({
        queryKey: ["trade"],
      });
    },
    onError: (err) => {
      toast.error(err.toString() || " Something went wrong ");
    },
  });

  const isLoading = isScalingIn || isScalingOut || isScaleInEditing || isScaleOutEditing;
  return {
    isLoading,
    scaleIn,
    scaleOut,
    editScaleIn,
    editScaleOut,
  };
};
